
export enum InsertType {
	AtCursor = 1,
	Replacement = 2,
}

export interface InsertTemplateCommandModel {
	template: string;
	insertType: InsertType;
}